import { registerReactControllerComponents } from '@symfony/ux-react';
import '../../bootstrap.js';

registerReactControllerComponents(
    require.context(
        '../controllers',
        true,
        /Index\.(j|t)sx?$/
    )
);
